import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA3h-PZsYMQEENCtGiIiJfTP0oN2VNOrHI",
  authDomain: "forms-details-755dd.firebaseapp.com",
  projectId: "forms-details-755dd",
  storageBucket: "forms-details-755dd.appspot.com",
  messagingSenderId: "586112738611",
  appId: "1:586112738611:web:cf400dc16968f6e8db0a46",
  measurementId: "G-7CSNZ1HEJ2"
};

const app = initializeApp(firebaseConfig);

let analytics = null;
isSupported().then((yes) => {
  if (yes) {
    try {
      analytics = getAnalytics(app);
    } catch (e) {
      analytics = null;
    }
  }
});

const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { app, analytics, db, storage, auth };
